import request from '@/utils/request'

// 获取园区列表
export function listCommunitys(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/community.listCommunitys',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      if (res.code == 0) {
        resolve({
          data: res.communitys,
          total: res.total,
          records: res.records
        })
      } else {
        reject(new Error(res.msg || '获取园区列表失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryBusinessOpportunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.listBusinessOpportunity',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function saveBusinessOpportunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.saveBusinessOpportunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


// 修改合同类型
export function updateBusinessOpportunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.updateBusinessOpportunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除合同类型
export function deleteBusinessOpportunity(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.deleteBusinessOpportunity',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


export function getBusinessOpportunityById(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.getBusinessOpportunityById',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}


// 上传图片
export function uploadImage(data) {
  return new Promise((resolve, reject) => {
    const formData = new FormData()
    formData.append('uploadFile', data.file)

    request({
      url: '/callComponent/upload/uploadFile/uploadImage',
      method: 'post',
      data: formData,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function selectStaffInfos(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/query.staff.infos',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function queryBusinessOpportunityEcharts(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/businessOpportunity.selectBusinessOpportunityEcharts',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

export function getRoomInfoByCommunity(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/room.queryRoomsInfoCmd',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}